import gql from 'graphql-tag'

export const GET_DOC = gql`
  query documentPdf($resultId: String, $finalAnswers: [RespostasFinaisQuizInput], $quizContent: String, $pdfType: String!){
    documentPdf(resultId: $resultId, finalAnswers: $finalAnswers, quizContent: $quizContent, pdfType: $pdfType)
  }
`